export default __webpack_public_path__ + "static/media/whyIsStudyDone_lg_woman.5079efac.png";